export default __webpack_public_path__ + "static/media/cog.94aedd38.png";